import React, { useId } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LeaderJersey.css';

// Цвета футболок — фирменные, одинаковые в светлой и темной теме (как у медалей)
const JERSEY_COLORS = {
  gc: { main: '#D9A21B', light: '#EEC24A', edge: '#8A6410' },
  category: { main: '#1E9E4A', light: '#3FC56B', edge: '#0E5E2A' }
};

// Велофутболка: короткие рукава, вырез ворота, на груди — категория
const Jersey = ({ type, label, title }) => {
  const color = JERSEY_COLORS[type];
  // id градиента уникален на странице: футболок в протоколе много
  const gradientId = `leader-jersey-${useId().replace(/:/g, '')}`;

  return (
    <svg
      className="leader-jersey"
      width="28"
      height="28"
      viewBox="0 0 32 32"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color.light} />
          <stop offset="100%" stopColor={color.main} />
        </linearGradient>
      </defs>
      <path
        d="M11.5 2.5 L4.5 5.5 L1 13 L6 15 L7.5 12 L7.5 29.5 L24.5 29.5 L24.5 12 L26 15 L31 13 L27.5 5.5 L20.5 2.5 Q16 7.5 11.5 2.5 Z"
        fill={`url(#${gradientId})`}
        stroke={color.edge}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      {/* Окантовка рукавов */}
      <path d="M1.9 11 L6.9 13.1 M30.1 11 L25.1 13.1" stroke={color.edge} strokeWidth="1" strokeLinecap="round" />
      {label && (
        <text
          x="16"
          y="25"
          textAnchor="middle"
          fill="#2B2B2B"
          fontSize={label.length > 3 ? 10 : 12}
          fontWeight="800"
          fontFamily="Arial, Helvetica, sans-serif"
          // Буквы высокие и узкие: по ширине надпись не выходит за корпус футболки
          textLength={label.length > 3 ? 15 : 12}
          lengthAdjust="spacingAndGlyphs"
        >
          {label}
        </text>
      )}
    </svg>
  );
};

// Футболки лидера рядом с ФИО: генеральная классификация и/или категория мощности
const LeaderJerseys = ({ jerseys }) => {
  const { t } = useLanguage();

  if (!jerseys || jerseys.length === 0) return null;

  return (
    <span className="leader-jerseys">
      {jerseys.map(jersey => (
        jersey.type === 'gc' ? (
          <Jersey key="gc" type="gc" title={t('results.gc_leader')} />
        ) : (
          <Jersey
            key={`category-${jersey.category}`}
            type="category"
            label={jersey.category}
            title={`${t('results.category_leader')} ${jersey.category}`}
          />
        )
      ))}
    </span>
  );
};

// Пояснение над общим зачетом: что означают футболки
export const LeaderJerseysLegend = () => {
  const { t } = useLanguage();

  return (
    <div className="leader-jerseys-legend">
      <span className="leader-jerseys-legend-item">
        <Jersey type="gc" title={t('results.gc_leader')} />
        {t('results.gc_leader')}
      </span>
      <span className="leader-jerseys-legend-item">
        <Jersey type="category" label="A1" title={t('results.category_leader')} />
        {t('results.category_leader_legend')}
      </span>
    </div>
  );
};

export default LeaderJerseys;
